var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"layout"}},[_c('app-header'),_c('v-main',{attrs:{"id":"conteudo-lay"}},[_vm._t("conteudo")],2),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }